import request from "@/http/request"
import {
  getSyncLogData,
  syncExamData,
  getEnableSyncExamState,
  syncCheckState,
  getEnableSyncCheckState
} from '@/http/api'

export const getSyncLogDataInfo = (data) => {
    return request({
        url: getSyncLogData,
        data
    })
}
export const syncExamDataSet = (data) => {
  return request({
      url: syncExamData,
      data
  })
}
export const getEnableSyncExamStateInfo = (data) => {
  return request({
      url: getEnableSyncExamState,
      data
  })
}
export const getEnableSyncCheckStateInfo = (data) => {
  return request({
      url: getEnableSyncCheckState,
      data
  })
}
export const syncCheckStateSet = (data) => {
  return request({
      url: syncCheckState,
      data
  })
}